import script from "./PlansPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlansPage.vue?vue&type=script&setup=true&lang=js"

import "./PlansPage.vue?vue&type=style&index=0&id=5979b4b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5979b4b5"]])

export default __exports__